module.exports = __webpack_public_path__ + "static/media/Ellipsis-horizontal.ce8682be.svg";